export type StudyMultipleDevicesSignInConfig = {
  patientMultipleDevicesSignIn: boolean;
};

export const StudyMultipleDevicesSignInConfig = {
  ALLOW_MULTIPLE_DEVICES_SIGN_IN: true,
};
